export const LOGO_MARK = "/assets/logo-mark.png";

export const AMBASSADOR_IMG = "/assets/ambassador-hero.png";
export const INTERIOR_IMG = "/assets/site/why-choose-us.jpg";
export const MEMBERSHIP_IMG = "/assets/site/membership.jpg";

export const YOUTUBE_ID = "NbxSVx8PVxg";
export const VIDEO_THUMB = "/assets/site/carlton-video-thumb.png";

export const PHONE = "";

export const CONTACT_INFO = {
  email: "info@carltonwellnesscenter.com",
  corporate: "EBG House, Hyderabad, Telangana, India",
  hours: "Mon – Sat | 10:00 AM – 7:00 PM",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Wellness Programs", to: "/programs", dropdown: true },
  { label: "Memberships", to: "/memberships" },
  { label: "Franchise Opportunity", to: "/franchise" },
  { label: "Locations", to: "/locations" },
  { label: "Contact Us", to: "/contact" },
];

export const HERO_PROGRAMS = [
  { label: "Prevention & Longevity", icon: "ShieldCheck", slug: "prevention-longevity" },
  { label: "Rehab & Recovery", icon: "HeartPulse", slug: "rehab-recovery" },
  { label: "Mental Wellbeing", icon: "Brain", slug: "mental-wellbeing" },
  { label: "Slimming & Metabolic Reset", icon: "PersonStanding", slug: "slimming-metabolic-reset" },
  { label: "Anti-Ageing & Kayakalp", icon: "Sparkles", slug: "anti-ageing-kayakalp" },
  { label: "Skin, Hair & Body Wellness", icon: "Droplets", slug: "skin-hair-body-wellness" },
  { label: "Nutrition & Products", icon: "Apple", slug: "nutrition-products" },
  { label: "Community Wellness", icon: "Users", slug: "community-wellness" },
];

export const TRUST_ITEMS = [
  { icon: "Workflow", title: "Protocol-Led", sub: "Wellness Designed for Better Living" },
  { icon: "Layers", title: "8", sub: "Core Wellness Pillars", numeric: true },
  { icon: "UserRound", title: "Personalized", sub: "Care for Every Individual" },
  { icon: "Gem", title: "Premium", sub: "Hospitality Meets Healthcare" },
];

export const PROGRAM_DETAILS = [
  {
    slug: "prevention-longevity",
    title: "Prevention & Longevity",
    tagline: "Live longer. Live better.",
    desc: "Assessment-led preventive care that identifies risks early and builds a personalised roadmap for lasting vitality — so wellness begins long before illness ever does.",
    image: "/assets/programs/prevention.jpg",
    therapies: [
      "Comprehensive Health Assessments",
      "Longevity & Vitality Protocols",
      "IV Wellness & Micronutrient Support",
      "Detox & Cleanse Programs",
      "Sleep & Stress Optimisation",
      "Movement & Mobility Coaching",
    ],
    benefits: [
      "Early identification of health risks",
      "A personalised prevention plan",
      "Improved energy and immunity",
      "Better, deeper sleep quality",
      "Sustainable healthy habits",
      "Measurable progress tracking",
    ],
  },
  {
    slug: "rehab-recovery",
    title: "Rehab & Recovery",
    tagline: "Recover stronger. Move freer.",
    desc: "Expert-supervised rehabilitation pathways and advanced recovery therapies that restore strength, mobility and confidence — for athletes, post-surgery recovery and everyday life.",
    image: "/assets/programs/rehab.jpg",
    therapies: [
      "Physiotherapy & Sports Rehab",
      "Cryotherapy & Cold Plunge",
      "Compression & Percussion Therapy",
      "Deep Tissue & Sports Massage",
      "Hydrotherapy Sessions",
      "Post-Surgery Recovery Protocols",
    ],
    benefits: [
      "Faster recovery from injury",
      "Reduced pain and inflammation",
      "Restored strength and mobility",
      "Lower risk of re-injury",
      "Expert-supervised rehabilitation",
      "Confidence to return to activity",
    ],
  },
  {
    slug: "mental-wellbeing",
    title: "Mental Wellbeing",
    tagline: "A calmer, clearer mind.",
    desc: "Private, judgement-free spaces and guided practices for stress recovery, better sleep and emotional resilience — designed as a practice, not a one-time fix.",
    image: "/assets/programs/mental.jpg",
    therapies: [
      "Guided Meditation & Breathwork",
      "Stress Management Counselling",
      "Sleep Therapy Programs",
      "Mindfulness & Focus Training",
      "Sound & Relaxation Therapy",
      "Digital Detox Sessions",
    ],
    benefits: [
      "Reduced stress and anxiety",
      "Improved focus and clarity",
      "Deeper, more restful sleep",
      "Greater emotional resilience",
      "Healthy coping practices",
      "Better work-life balance",
    ],
  },
  {
    slug: "slimming-metabolic-reset",
    title: "Slimming & Metabolic Reset",
    tagline: "Transform your body. Reset your metabolism.",
    desc: "Science-backed body transformation combining clinical assessments, EMS technology and medical nutrition — for results that are visible, measurable and sustainable.",
    image: "/assets/programs/slimming.jpg",
    therapies: [
      "Body Composition Analysis",
      "EMS Training Sessions",
      "Medical Nutrition Therapy",
      "Metabolic Reset Programs",
      "Inch-Loss & Contouring Therapies",
      "Fitness & Lifestyle Coaching",
    ],
    benefits: [
      "Sustainable weight management",
      "Improved metabolic health",
      "Personalised nutrition plans",
      "Visible body contouring",
      "Continuous progress monitoring",
      "Long-term lifestyle change",
    ],
  },
  {
    slug: "anti-ageing-kayakalp",
    title: "Anti-Ageing & Kayakalp",
    tagline: "Ancient wisdom. Modern science.",
    desc: "Premium rejuvenation rituals inspired by India's Kayakalp tradition, elevated with modern age-management science — so you feel renewed from the inside out.",
    image: "/assets/programs/antiageing.jpg",
    therapies: [
      "Kayakalp Rejuvenation Rituals",
      "Anti-Ageing Facials & Skin Therapy",
      "Collagen & Skin Nutrition Programs",
      "Ayurvedic Rasayana Therapies",
      "Hair & Scalp Rejuvenation",
      "Hormonal Balance Support",
    ],
    benefits: [
      "Youthful, radiant skin",
      "Renewed energy and vitality",
      "Slower visible ageing",
      "Holistic inner rejuvenation",
      "Time-tested Indian therapies",
      "Confidence that shows",
    ],
  },
  {
    slug: "skin-hair-body-wellness",
    title: "Skin, Hair & Body Wellness",
    tagline: "Look as good as you feel.",
    desc: "Dermatologist-guided aesthetic care in private, premium suites — high-touch facials, hair restoration and body therapies with honest, lasting results.",
    image: "/assets/programs/skin.jpg",
    therapies: [
      "Advanced Medi-Facials",
      "Skin Brightening & Clarifying Treatments",
      "Hair Restoration & Scalp Therapy",
      "Body Polishing & Spa Rituals",
      "Laser & Aesthetic Services",
      "Dermatologist-Guided Care Plans",
    ],
    benefits: [
      "Healthier, glowing skin",
      "Stronger, fuller hair",
      "Safe, clinically guided treatments",
      "Premium private care suites",
      "Customised home-care guidance",
      "Lasting, visible results",
    ],
  },
  {
    slug: "nutrition-products",
    title: "Nutrition & Products",
    tagline: "Fuel your wellness journey.",
    desc: "Clinical nutrition consultations, gut-health programs and a curated range of wellness products — because every protocol works better when your plate does too.",
    image: "/assets/programs/nutrition.jpg",
    therapies: [
      "Clinical Nutrition Consultations",
      "Personalised Diet Plans",
      "Gut Health Programs",
      "Wellness Supplements & Products",
      "Detox Nutrition Support",
      "Cooking & Lifestyle Guidance",
    ],
    benefits: [
      "Balanced, sustainable nutrition",
      "Improved digestion and gut health",
      "Curated, quality-checked products",
      "Expert nutritionist support",
      "Diet plans that fit your life",
      "Energy that lasts all day",
    ],
  },
  {
    slug: "community-wellness",
    title: "Community Wellness",
    tagline: "Wellness is better together.",
    desc: "Group programs, health camps and neighbourhood wellness circles that make premium, protocol-led wellbeing accessible to families, workplaces and communities.",
    image: "/assets/programs/community.jpg",
    therapies: [
      "Group Yoga & Meditation Sessions",
      "Community Health Camps",
      "Corporate Wellness Programs",
      "Wellness Workshops & Talks",
      "Senior Citizen Wellness Circles",
      "Family Wellness Programs",
    ],
    benefits: [
      "Belonging and shared motivation",
      "Accessible group programs",
      "Healthier neighbourhoods",
      "Learning directly from experts",
      "Shared wellness rituals",
      "A community that cares",
    ],
  },
];

export const PROGRAMS = PROGRAM_DETAILS.map((p) => ({
  title: p.title,
  image: p.image,
  slug: p.slug,
}));

export const PROMISE_ITEMS = [
  { icon: "HandHeart", title: "Holistic Care", desc: "Complete wellbeing for mind, body and lifestyle." },
  { icon: "FlaskConical", title: "Science + Tradition", desc: "Evidence-based protocols with time-tested therapies." },
  { icon: "Building2", title: "Premium Facilities", desc: "World-class amenities and recovery spaces." },
  { icon: "ClipboardCheck", title: "Personalised Protocols", desc: "Custom plans with continuous monitoring and support." },
];

export const STATS = [
  { value: 25, suffix: "+", label: ["Wellness Centers", "Across India"] },
  { value: 100000, suffix: "+", label: ["Happy Members", "& Counting"] },
  { value: 100, suffix: "+", label: ["Expert Doctors &", "Therapists"] },
  { value: 8, suffix: "", label: ["Core Wellness", "Pillars"] },
];

export const FRANCHISE_ITEMS = [
  { icon: "ShieldCheck", title: "Trusted by Design", desc: "Company-Operated Excellence" },
  { icon: "MapPin", title: "Planned Centers", desc: "25+ Centers Expanding Across India" },
  { icon: "UserRound", title: "Personalized Care", desc: "Tailored Wellness Journeys for Every You" },
  { icon: "Flower2", title: "Premium Experience", desc: "World-Class Facilities & Hospitality" },
];

// ---------- Franchise page ----------
export const WHY_PARTNER = [
  { icon: "Users", title: "High Demand Category", desc: "Wellness is no longer a luxury. It's a lifestyle priority for every age group." },
  { icon: "Settings", title: "Proven Operating System", desc: "End-to-end systems for setup, operations, staff training, protocols and quality control." },
  { icon: "TrendingUp", title: "Strong Unit Economics", desc: "Multiple revenue streams with high repeat business and membership continuity." },
  { icon: "HandCoins", title: "Company Operated Model", desc: "We operate the center, you invest and earn attractive, transparent returns." },
  { icon: "Headset", title: "End-to-End Support", desc: "Site selection, design, setup, marketing, operations and ongoing support." },
  { icon: "ShieldCheck", title: "Trusted Brand & Leadership", desc: "Backed by the vision of Dr. Irfan Khan and the strength of EBG Group." },
];

export const ADVANTAGE_POINTS = [
  "Premium brand positioning",
  "Science-backed protocols and expert-led care",
  "Holistic wellness across mind, body and lifestyle",
  "Technology-enabled operations",
  "High membership retention and repeat visits",
  "Scalable model across cities and communities",
];

export const JOURNEY_STEPS = [
  { icon: "PenLine", title: "Enquiry", desc: "Submit your details and investment interest." },
  { icon: "PhoneCall", title: "Discovery Call", desc: "We'll learn, understand your goals and answer your questions." },
  { icon: "MapPin", title: "Site Evaluation", desc: "We evaluate the location and project potential together." },
  { icon: "FileText", title: "Agreement", desc: "We finalise terms and move forward with clarity." },
  { icon: "Wrench", title: "Setup & Launch", desc: "We set up, launch and operate your Carlton Wellness Center." },
  { icon: "TrendingUp", title: "Grow Together", desc: "We support your growth with marketing, operations and innovations." },
];

// ---------- About page ----------
export const DIFFERENTIATORS = [
  { icon: "Building2", title: "Company Operated", desc: "Consistent quality, standardized protocols across every center." },
  { icon: "ShieldCheck", title: "Protocol-Led Approach", desc: "Science-backed protocols and expert supervision for real results." },
  { icon: "Users", title: "Holistic Wellness", desc: "Mind, body, nutrition and lifestyle — addressed together." },
  { icon: "Flower2", title: "Inspired by Tradition", desc: "Ancient wisdom, modern science and world-class practices." },
  { icon: "Award", title: "Premium Experience", desc: "Hospitality-led spaces, personalized care and complete privacy." },
];

export const CORE_VALUES = [
  { icon: "HandHeart", title: "Care", desc: "We care deeply for every individual's wellbeing." },
  { icon: "ShieldCheck", title: "Integrity", desc: "Honest protocols, transparent practices and lasting relationships." },
  { icon: "Award", title: "Excellence", desc: "World-class facilities and expert-led experiences." },
  { icon: "PersonStanding", title: "Empowerment", desc: "We educate and empower you to take charge of your health." },
  { icon: "Users", title: "Community", desc: "Building healthier communities, together." },
];

export const VMP = [
  { icon: "Eye", title: "Our Vision", desc: "To be India's most trusted and admired wellness network, setting the standard for holistic wellbeing." },
  { icon: "Target", title: "Our Mission", desc: "To make premium wellness accessible and sustainable for every individual, family and community we serve." },
  { icon: "Star", title: "Our Promise", desc: "To deliver personalized care, measurable results and a premium experience at every touchpoint." },
];

export const EXPERIENCE_STEPS = [
  { n: "01", title: "Assess", desc: "In-depth assessments to understand your unique needs.", image: "/assets/site/exp-assess.jpg" },
  { n: "02", title: "Personalize", desc: "Custom protocols designed by experts for measurable outcomes.", image: "/assets/site/exp-personalize.jpg" },
  { n: "03", title: "Experience", desc: "Guided sessions and therapies in a premium, soothing environment.", image: "/assets/programs/mental.jpg" },
  { n: "04", title: "Nourish", desc: "Nutrition guidance and wellness products to fuel your journey.", image: "/assets/programs/nutrition.jpg" },
  { n: "05", title: "Track", desc: "Continuous monitoring and expert support at every step.", image: "/assets/programs/antiageing.jpg" },
  { n: "06", title: "Transform", desc: "Sustainable results for a healthier, happier you.", image: "/assets/site/values-lounge.jpg" },
];

export const TRUST_POINTS = [
  { icon: "Gem", label: "Luxury Spaces" },
  { icon: "Stethoscope", label: "Expert Care" },
  { icon: "Cpu", label: "Advanced Technology" },
  { icon: "Lock", label: "Complete Privacy" },
  { icon: "Sparkles", label: "Signature Hospitality" },
];

// ---------- Locations ----------
export const FEATURED_CENTER = {
  name: "Carlton Wellness Centre — Manipal, Udupi",
  status: "Now Open",
  address:
    "First Floor, Door No. 16-91, Sairam Central Mall, Manipal, Ananth Nagar 1st Stage, Udupi, Karnataka 576104",
  phone: "098459 95279",
  hours: "Mon – Sat | 10:00 AM – 7:00 PM",
  maps:
    "https://www.google.com/maps/search/?api=1&query=Carlton+Wellness+Centre+Sairam+Central+Mall+Manipal+Udupi+Karnataka+576104",
  image: "/assets/site/location-manipal.png",
};

export const COMING_SOON_CITIES = [
  "Hyderabad",
  "Bengaluru",
  "Mumbai",
  "Delhi NCR",
  "Chennai",
  "Pune",
];

// ---------- Footer ----------
export const FOOTER_QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Wellness Programs", to: "/programs" },
  { label: "Community Wellness", to: "/programs/community-wellness" },
  { label: "Locations", to: "/locations" },
  { label: "Contact Us", to: "/contact" },
];

export const FOOTER_PARTNER_LINKS = [
  { label: "Franchise Opportunity", to: "/franchise" },
  { label: "Why Partner With Us", to: "/franchise#why-partner" },
  { label: "Partner Support", to: "/franchise#franchise-team" },
  { label: "Enquire Now", to: "/franchise#franchise-team" },
];

export const FOOTER_PROGRAMS = PROGRAM_DETAILS.map((p) => ({
  label: p.title,
  to: `/programs/${p.slug}`,
}));


// ---------- Memberships page ----------
export const MEMBERSHIP_PLANS = [
  {
    slug: "student-reset-club",
    name: "Student Reset Club",
    icon: "GraduationCap",
    features: [
      "3 × 60-min massages (Relaxation / Aroma / Sleep Reset)",
      "20% off facials",
      "15% off add-ons",
      "Free Steam (1 per visit)",
    ],
    duration: "3 Months",
    scheduleNote: "Mon–Thu",
    price: "₹6,999",
    priceNote: "Tax included",
  },
  {
    slug: "signature-carlton-membership",
    name: "Signature Carlton Membership",
    icon: "Crown",
    features: [
      "₹18,000 wallet credit",
      "₹6,000 bonus credit",
      "15% off retail",
      "1 complimentary birthday therapy (60 mins)",
      "Priority weekend booking",
    ],
    duration: "6 Months",
    price: "₹18,000",
    strikePrice: "₹24,000",
    featured: true,
  },
  {
    slug: "elite-recovery-club",
    name: "Elite Recovery Club",
    icon: "Flower2",
    features: [
      "₹35,000 wallet credit",
      "₹13,000 bonus credit",
      "1 complimentary Deep Muscle Release (75 min)",
      "2 Steam Rituals per month",
      "20% retail discount",
      "Free express add-on every visit",
    ],
    duration: "6 Months",
    price: "₹35,000",
    strikePrice: "₹48,000",
  },
  {
    slug: "couples-wellness-pass",
    name: "Couples Wellness Pass",
    icon: "HeartHandshake",
    features: [
      "6 × Couple 60-min therapies",
      "2 × Bath Ritual upgrades",
      "15% retail discount",
    ],
    duration: "6 Months",
    price: "₹28,000",
    strikePrice: "₹28,000",
  },
];

export const MONTHLY_WELLNESS_PLANS = [
  {
    tier: "Silver",
    number: "1.",
    desc: "1 × 60-min massage, 10% extra therapies",
    price: "₹3,999",
    cadence: "Monthly",
  },
  {
    tier: "Gold",
    number: "2.",
    desc: "2 × 60-min therapies, Free steam, 15% retail discount",
    price: "₹6,999",
    cadence: "Monthly",
    highlight: true,
  },
];

export const MEMBERSHIP_PILLARS = [
  { icon: "Flower2", title: "Protocol-Led", sub: "Wellness Ecosystem" },
  { icon: "Stethoscope", title: "Expert-Led", sub: "Care & Guidance" },
  { icon: "UserRound", title: "Personalized", sub: "Wellness Programs" },
  { icon: "Sparkles", title: "World-Class Facilities", sub: "& Premium Experience" },
];

export const MEMBERSHIP_KEYWORDS = [
  "Prevention",
  "Recovery",
  "Slimming",
  "Anti-Ageing",
  "Mental Wellbeing",
  "Lifestyle Health",
];
